// extracted by mini-css-extract-plugin
module.exports = {"twoColumnSection":"TwoColumnSection-module--twoColumnSection--18uSC","twoColumnNps":"TwoColumnSection-module--twoColumnNps--26RGG","nps":"TwoColumnSection-module--nps--35tGv"};